import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux'
import { bucket_url } from '../../constants/const'
import Error404 from '../../components/Error/Error404'
import Loading from '../../components/layouts/Loading'
import { useParams } from 'react-router-dom'
import { Container, Row, Col, Nav, Table } from "react-bootstrap";
import Collapsible from 'react-collapsible';
import CollegeDetailsHeader from '../../components/collegeDetailsHeader/collegeDetailsHeader.component';
import PublicationCard from '../../components/publicationCard/publicationCard.component';
import PageTitle from '../../components/pageTitle/pageTitle.component';

import SirSalimullahMedicalCollegePhoto from '../../assets/images/banners/SirSalimullahMedicalCollege.jpg';
import CoverImage from '../../assets/images/publications/cover-1.png';

import './collegeDetailsPage.css';

const CollegeDetailsPage = props => {

    const { collegeId, categoryId } = useParams()

    const { loading, college, collegeCategory } = useSelector(state => state.all)

    const [singleCollege, setSingleCollege] = useState({})
    const [category, setCategory] = useState({})

    useEffect(() => {
        if (college && college.length > 0) {
            setSingleCollege(college.find(item => item._id === collegeId))
            setCategory(collegeCategory.find(item => item._id === categoryId))
        }
    }, [college, collegeId])

    useEffect(() => {

        if (!loading && singleCollege && category) {
            if (singleCollege.description) {
                document.getElementById('college-details').innerHTML = singleCollege.description
            }
        }
    }, [college, singleCollege])

    return (
        loading ? <Loading /> : singleCollege && category ? <>
            <CollegeDetailsHeader
                title={singleCollege.name}
                cover={`${bucket_url}${singleCollege.coverPhoto}`}
                category={category}
            >
                <p>
                    {singleCollege.excerpt}
                </p>
            </CollegeDetailsHeader>

            <section id="overview" className="py-5 mb-5">
                <Container>
                    <Row>
                        <Col>
                            <div id='college-details'>

                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>


        </> : <Error404 />
    )
}

export default CollegeDetailsPage;